import { render, staticRenderFns } from "./TabBreadcrumbItem.vue?vue&type=template&id=5e8aabcf&scoped=true&"
import script from "./TabBreadcrumbItem.vue?vue&type=script&lang=ts&"
export * from "./TabBreadcrumbItem.vue?vue&type=script&lang=ts&"
import style0 from "./TabBreadcrumbItem.vue?vue&type=style&index=0&id=5e8aabcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8aabcf",
  null
  
)

export default component.exports